import { observable, action, makeObservable } from 'mobx';

/**
 * Client-only state for the Linehaul screen: what the operator has hidden, tagged or searched for.
 *
 * Every server read lives in TanStack Query under src/hooks/linehaul, so this store deliberately
 * holds no API instance and no request state. Anything derived from a server payload belongs in
 * src/selectors/linehaul, not here.
 */
class LinehaulStore {
  searchKeyword = '';

  hiddenCategories = [];

  selectedTags = [];

  constructor() {
    makeObservable(this, {
      searchKeyword: observable,
      hiddenCategories: observable,
      selectedTags: observable,
      setSearchKeyword: action,
      setHiddenCategories: action,
      setSelectedTags: action,
      resetFilters: action,
    });
  }

  setSearchKeyword = (keyword) => {
    this.searchKeyword = keyword;
  };

  setHiddenCategories = (categories) => {
    this.hiddenCategories = categories;
  };

  setSelectedTags = (tags) => {
    this.selectedTags = tags;
  };

  resetFilters = () => {
    this.hiddenCategories = [];
    this.selectedTags = [];
    this.searchKeyword = '';
  };
}

export default LinehaulStore;
